import ClientTable from "./components/ClientTable";

const Favorites = () => {
  return <ClientTable showFavoritesOnly={true} />;
};

export default Favorites;
